import {
  Box,
  Center,
  Divider,
  Group,
  Loader,
  Skeleton,
  Stack,
  Text,
  useMantineTheme,
} from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';
import { Panel } from 'components/Panel';
import { i18nKeys, useTranslation } from 'locales';

type AiCallLoaderProps = {};

export const AiCallLoader = ({}: AiCallLoaderProps) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();

  return (
    <Panel>
      <Group align="start" wrap="nowrap" justify="space-between">
        <Stack flex={1}>
          <Group w="70%" justify="space-between">
            <Skeleton height={20} width="20%" />
            <Skeleton height={20} width="40%" />
          </Group>
          <Group w="70%" justify="space-between">
            <Skeleton height={20} width="30%" />
            <Skeleton height={20} width="40%" />
          </Group>
          <Group w="70%" justify="space-between">
            <Skeleton height={20} width="20%" />
            <Skeleton height={20} width="40%" />
          </Group>
          <Group w="70%" justify="space-between">
            <Skeleton height={20} width="40%" />
            <Skeleton height={20} width="40%" />
          </Group>
          <Group w="70%" justify="space-between">
            <Skeleton height={20} width="15%" />
            <Skeleton height={20} width="40%" />
          </Group>
        </Stack>
        <Box miw="50%" bg="purple.2" p="lg" style={{ borderRadius: 8 }}>
          <Group mb="md">
            <IconSparkles stroke={1.5} size={20} color={theme.colors.purple[6]} />
            <Text fw="bold" c="purple.6">
              {t(i18nKeys.REMINDER.AI_CALL_SUMMARY)}
            </Text>
          </Group>
          <Stack gap="sm">
            <Skeleton height={20} />
            <Skeleton height={20} width="90%" />
            <Skeleton height={20} width="90%" />
          </Stack>
        </Box>
      </Group>
      <Divider my="xl" />
      <Center>
        <Loader />
      </Center>
    </Panel>
  );
};
